import { formatAsCurrency, Typography } from '@la/ds-ui-components';
import { useConsolidatedCheckout } from 'lib/context/ConsolidatedCheckoutContext/ConsolidatedCheckoutContext';
import styles from './CheckoutBillingSummaryFees.module.scss';

export const TAX_AMOUNT_LABEL = 'Taxes';
export const TRANSACTION_FEES_LABEL = 'Transaction fees';

export function CheckoutBillingSummaryFees() {
  const { taxAmount = '', transactionFees } = useConsolidatedCheckout();

  const hasTaxAmount = Number.parseFloat(taxAmount);
  const hasTransactionFees = Number.parseFloat(transactionFees);

  return (
    <div className={styles.checkoutBillingSummaryFees}>
      {hasTaxAmount ? (
        <CheckoutBillingSummaryFee fee={taxAmount} label={TAX_AMOUNT_LABEL} />
      ) : null}
      {hasTransactionFees ? (
        <CheckoutBillingSummaryFee
          fee={transactionFees}
          label={TRANSACTION_FEES_LABEL}
        />
      ) : null}
    </div>
  );
}

function CheckoutBillingSummaryFee({
  fee,
  label,
}: Readonly<{
  fee: string;
  label: string;
}>) {
  const formattedFee = formatAsCurrency(Number.parseFloat(fee));
  return (
    <div className={styles.checkoutBillingSummaryFee}>
      <span> {label}:</span>
      <Typography size="medium" variant="ui" weight="bold">
        {formattedFee}
      </Typography>
    </div>
  );
}
